import type { TFunction } from 'i18next';
import type { FeatureUsageRow } from '@/api/generated';

/** The AI features the contract names; a re-vendor that adds one is a compile error here. */
type AiFeature = NonNullable<FeatureUsageRow['feature']>;
const AI_FEATURES: Record<AiFeature, true> = {
  IMPORT_MAPPING: true,
  CATEGORY_SUGGESTION: true,
  ENVELOPE_ANALYSIS: true,
  MEETING_SUMMARY: true,
  MATCH_SUGGESTION: true,
  DOMAIN_SETUP: true,
  PAYEE_SUGGESTION: true,
  PAYEE_PATTERN: true,
  FINANCIAL_ASSISTANT: true,
  SUPPORT_ASSISTANT: true,
};

/**
 * A feature's catalog wording; "Unknown" for one the contract does not name — never the raw code
 * (TXT-006). The one map for AI activity (TMMAPP-0080) and Billing's accrued-AI list (TMMAPP-0085).
 */
export function featureLabel(t: TFunction, feature: string): string {
  return Object.hasOwn(AI_FEATURES, feature)
    ? t(`aiHistory.featureName.${feature}`)
    : t('aiHistory.unknownFeature');
}
